import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../../core/services/language.service';
import { AlarmType } from '../enums/alarm-type.enum';
import { EquipmentAlarmRuleSelectionType } from '../enums/equipment-alarm-rule-selection-type.enum';

@Pipe({
  name: 'alarmSelectionType',
})
export class AlarmSelectionTypeResolverPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(value: string, type?: AlarmType): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case EquipmentAlarmRuleSelectionType.LABEL:
        return this.translate('shared.pipes.alarmSelectionType.labels');
      case EquipmentAlarmRuleSelectionType.EQUIPMENT_TYPE:
        return this.translate('shared.pipes.alarmSelectionType.equipmentTypes');
      case EquipmentAlarmRuleSelectionType.ALL_EQUIPMENT:
        if (AlarmType.INACTIVE_TELEMATICS_UNIT === type) {
          return this.translate('shared.pipes.alarmSelectionType.allEquipmentsWithTelematicsUnit');
        } else {
          return this.translate('shared.pipes.alarmSelectionType.allEquipments');
        }
      case EquipmentAlarmRuleSelectionType.EQUIPMENT:
        return this.translate('shared.pipes.alarmSelectionType.equipments');
      case EquipmentAlarmRuleSelectionType.CUSTOMER:
        return this.translate('shared.pipes.alarmSelectionType.customer');
      case EquipmentAlarmRuleSelectionType.EQUIPMENT_STATUS:
        return this.translate('shared.pipes.alarmSelectionType.equipmentStatus');
      default:
        return this.translate('shared.pipes.alarmSelectionType.unknown');
    }
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
